import { useCallback } from "react";
import { useSetAtom } from "jotai";
import { comparisonHistoryAtom } from "../ComparativeAnalysisForm.atoms";
import { COMPARISON_HISTORY_SIZE_LIMIT } from "../ComparativeAnalysisForm.constants";
import type { ComparisonHistoryPayload } from "../ComparativeAnalysisForm.types";

// the history-atom is synced to the localstorage
export const useSetComparisonHistoryAtom = () => {
  const setHistory = useSetAtom(comparisonHistoryAtom);

  return useCallback(
    (historyItem: ComparisonHistoryPayload) => {
      setHistory((prevHistory) => {
        try {
          const newItem = JSON.stringify({
            ...historyItem,
            timestamp: new Date().toISOString(),
          });

          // Remove all occurrences of newItem from prevHistory
          const filteredHistory = prevHistory
            ? prevHistory.filter((item) => item !== newItem)
            : [];

          // Add new item to the beginning of the array and limit the array's length
          return [newItem, ...filteredHistory].slice(
            0,
            COMPARISON_HISTORY_SIZE_LIMIT
          );
        } catch (error) {
          console.warn(error);
          return prevHistory;
        }
      });
    },
    [setHistory]
  );
};
